module.exports = __webpack_public_path__ + "img/status-wallet.7452aef3.png";